import { i18n } from 'i18n/i18n';
import { BrStatus, PartnerStatus } from 'types/Partner';
import * as yup from 'yup';
import { OTHER_REASONS } from 'views/PartnerTabs/RejectWithdrawDialog/constant';

export const rejectWithdrawSchema = (modalType: BrStatus | PartnerStatus) =>
  yup.object().shape({
    rejectWithdrawReason: yup
      .string()
      .test('rejectWithdrawReason', i18n.t('more.error.reason'), function (value) {
        if ([PartnerStatus.WITHDRAWN, PartnerStatus.REJECTED].includes(modalType as PartnerStatus)) {
          return !!value;
        }
        return true;
      })
      .nullable(),
    rejectWithdrawReasonOthers: yup
      .string()
      .test('rejectWithdrawReasonOthers', i18n.t('more.error.otherReason'), function (value) {
        const { rejectWithdrawReason } = this.parent;
        if (rejectWithdrawReason === OTHER_REASONS) {
          return !!value;
        }
        return true;
      }),
  });
